import React, { useState, useEffect } from "react";
import { Container, Row, Card, Input, Form, Col, Button } from "reactstrap";
// import SigninImg from '../../assets/img/sign2.png';
import { ThreeDots } from "react-loader-spinner";
// import { AiFillApple, AiFillTwitterCircle } from "react-icons/ai";
// import { FcGoogle } from "react-icons/fc";
// import { BsFacebook } from "react-icons/bs";
import { TiEye } from "react-icons/ti";
import { IoMdEyeOff } from "react-icons/io";
import { useFormik } from "formik";
import logo from "../../assets/img/logo.png";
import { connect } from "react-redux";
import { setAuthState, loginUser } from "../../redux/actions";

import { NavLink } from "react-router-dom";
import { LoginValidate } from "./validation";
import { toast } from "react-toastify";

const Signin = ({
  // setAuthState,
  loginUser,
  loading,
  error,
  // message,
}) => {
  const [inputType, setInputType] = useState("password");

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validate: LoginValidate,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: (values) => {
      loginUser(values);
    },
  });

  useEffect(() => {
    if (!loading && error?.length) {
      toast.error(error);
    }
  }, [error, loading]);

  return (
    <div className="auth">
      <Row className="gx-0">
        <Col md="4" sm="12" lg="4" className="pr-0">
          <div className="signin-left">
            <Container>
              {/* <div className='signin-img-container '>
                                <img src={SigninImg} alt='signin-img' className='signin-img' />
                            </div> */}
              <div className="signin-text text-white pl-5 w-75 mx-auto">
                <h2 className="signin-header-text mt-5 mb-3">
                  Social media management made easy
                </h2>
                <h4 className="signin-subhead-text">
                  Spend less, stay organized & save time.
                </h4>
              </div>
            </Container>
          </div>
        </Col>
        <Col md="12" sm="12" lg="8" className="pl-0 mt-3">
          <div className="signin-right">
            {/* <Container> */}

            <div className="mx-auto  signin-form-wrapper">
              <div className="signin-logo text-center my-2 mb-4">
                <img src={logo} alt="ontriv-logo" width="200px" />
              </div>
              <Card className="px-md-3 px-xl-5 py-4  signin-form-card mb-1">
                <h4 className="text-center mb-4">Welcome Back!</h4>
                {/* <p className="text-center">Login with your Account Details</p> */}
                <Form onSubmit={formik.handleSubmit}>
                  {formik?.errors?.email && formik?.touched?.email ? (
                    <span className="text-danger text-left field-error">
                      {formik?.errors?.email}
                    </span>
                  ) : null}
                  <Input
                    type="email"
                    name="email"
                    placeholder="Email Address"
                    className={`w-100 ${
                      formik?.errors?.email ? "red-border" : ""
                    }`}
                    onChange={formik.handleChange}
                    value={formik?.values?.email}
                  />
                  {formik?.errors?.password && formik?.touched?.password ? (
                    <span className="text-danger text-left field-error">
                      Enter your password
                    </span>
                  ) : null}
                  <div className="password-container">
                    <div className="password-icon">
                      {inputType === "password" ? (
                        <TiEye
                          color="#E5E9F2"
                          size="30px"
                          onClick={() => {
                            setInputType("text");
                          }}
                        />
                      ) : (
                        <IoMdEyeOff
                          color="#000"
                          size="25px"
                          onClick={() => {
                            setInputType("password");
                          }}
                        />
                      )}
                    </div>
                    <input
                      className={`w-100 ${
                        formik?.errors?.password ? "red-border" : ""
                      }`}
                      type={inputType}
                      name="password"
                      placeholder="Password"
                      onChange={formik.handleChange}
                      value={formik?.values?.password}
                    />
                  </div>
                  <div className="d-flex justify-content-between align-items-center flex-wrap ">
                    <div className="d-flex  align-items-center">
                      <div className="input-check">
                        <Input
                          type="checkbox"
                          id="forgotPassword"
                          name="forgotPassword"
                          value="forgotPassword"
                          className="mb-0 border-dark"
                        />
                      </div>
                      <div className="ml-3 ">
                        <p className="mb-0" style={{ fontSize: "14px" }}>
                          Remember me
                        </p>
                      </div>
                    </div>
                    <div>
                      <p className="forgot-password mb-0">
                        {/* <span> */}
                        <a
                          className="forgot-password-link"
                          href="/auth/forgot-password"
                        >
                          Forgot Password?
                        </a>
                        {/* </span> */}
                      </p>
                    </div>
                  </div>

                  <Button type="submit" disabled={loading}>
                    {/* <Link
                                            className='w-100 login-link'
                                            to='/overview'
                                            onClick={() => {
                                                setAuthState(true);
                                            }}
                                        > */}
                    {loading ? (
                      <div className="text-center w-100 align-items-center">
                        <ThreeDots
                          color="white"
                          height={"12px"}
                          wrapperStyle={{ display: "block" }}
                        />
                      </div>
                    ) : (
                      "Log in"
                    )}
                    {/* Log in */}
                    {/* </Link> */}
                  </Button>

                  {/* <div className="py-3 mx-auto w-75">
                    <p className="easy-login">Easy Login</p>
                  </div>
                  <div className="mx-auto w-75 social-login d-flex justify-content-between">
                    <div>
                      <FcGoogle size="22px" />
                    </div>
                    <div>
                      <AiFillApple size="24px" />
                    </div>
                    <div>
                      <BsFacebook size="22px" color="#3C5A9A" />
                    </div>
                    <div>
                      <AiFillTwitterCircle size="26px" color="#1DA1F2" />
                    </div>
                    {/* <p className='easy-login'>Easy Login</p> */}
                  {/* </div> */}
                </Form>
              </Card>
              <div className="no-account my-4 py-4 text-center">
                <p className="mb-0">
                  Don’t have an account yet?
                  <span className="register-link">
                    <NavLink to="/auth/register">Sign Up</NavLink>
                  </span>
                </p>
              </div>
            </div>

            {/* </Container> */}
          </div>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = ({ auth }) => {
  const { error, message, loading } = auth;
  return {
    error: error?.login,
    message: message?.login,
    loading: loading?.login,
  };
};
export default connect(mapStateToProps, { setAuthState, loginUser })(Signin);
